// Módulo RH (cadastro de colaboradores, contratos PJ, desligamentos). Espelha backend/config.py
// ROLES_RH — mantenha em sincronia. Dados pessoais e sensíveis (LGPD). Decisão 2026-11-03: só
// admin por enquanto, enquanto o módulo é validado; o destino é RH + PESSOA&CULTURA.
export const ROLES_RH = ["admin"];
